import React from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useStyles } from './Styles'
import PageTitle from '../../PageTitle/PageTitle'
import UserGroupForm from './UserGroupForm'
import { NamedRoutes } from '../../../../routes'
import BreadCrumb from '../../BreadCrumb'
import { UserGroupConsumer } from '../../../../UserGroupContext'
import { FormLoader } from '../../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'

export default function UserGroupEditContent({ pageTitle, handleNotificationCall }) {
  const classes = useStyles()

  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.UserGroups' />,
          link: NamedRoutes.subscription.userGroups.list
        }
      ]} current={pageTitle ?? <FormattedMessage id='UserGroups.List.AddUserGroup.Title' />} />
      <PageTitle title={pageTitle ?? <FormattedMessage id='UserGroups.List.AddUserGroup.Title'/>}/>
      <UserGroupConsumer>
        {({ isEdit, isLoading, userGroupData, userGroupDataFailure, handleSubmit }) => (
          <Grid container spacing={4}>
            <Grid item xs={12} className={classes.EditProfileContentContainer}>
              <div className={classes.EditProfileContent}>
                {!!isLoading && <FormLoader loading={true} />}
                {!!userGroupDataFailure &&
                  <Alert severity="error"><FormattedMessage id='UpdateProfile.FormErrorAlert' /></Alert>
                }
                {!isLoading && (
                  !!isEdit ?
                    (!!userGroupData && !!Object.keys(userGroupData).length &&
                      <UserGroupForm userGroupData={userGroupData} onSubmit={handleSubmit} handleNotificationCall={handleNotificationCall} />
                    )
                    :
                    <UserGroupForm userGroupData={{}} onSubmit={handleSubmit} handleNotificationCall={handleNotificationCall} />
                )}
              </div>
            </Grid>
          </Grid>
        )}
      </UserGroupConsumer>

    </>
  )
}